import React from 'react';
import { Card } from 'react-bootstrap';
import AbstractClaimGroupChildPage from '@rd-web-markets/shared/dist/pages/abstract/AbstractClaimGroupChildPage';
import DataCenterExportTab from '@rd-web-markets/shared/dist/data_centre/DataCenterExportTab';

const DataCentreExportPage = AbstractClaimGroupChildPage({
  highlightedMenuItem: 'export_data',
  ClaimGroupChildPage: function ({ claimGroup, t }) {
    return (
      <div className="ps-4 pe-4">
        <h2 className='mt-3 mb-5 text-primary'>{t('export_data') || 'Export Data'}</h2>

        <Card>
          <Card.Body className="w-100 p-3">
            <DataCenterExportTab claimGroup={claimGroup} />
          </Card.Body>
        </Card>
      </div>
    );
  }
});

export default DataCentreExportPage;